const SubscriptionState = {
  subscription: [],
  subscription_cost: {},
  subscription_payload: {}
};

export default SubscriptionState;
